import { Menu, MenuItem } from "@mui/material";
import { useState } from "react";

import { MenuIcon } from "components/Icons";

export const TransactionMenu = ({
  transaction,
  handleUpdateTransactionStatus,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const _handleUpdateTransactionStatus = () => {
    handleUpdateTransactionStatus(transaction);
    handleClose();
  };

  return (
    <div>
      <MenuIcon onClick={handleClick} />
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {Boolean(transaction) && (
          <MenuItem
            onClick={_handleUpdateTransactionStatus}
            sx={{ fontSize: "13px" }}
          >
            {" "}
            Approve Transaction
          </MenuItem>
        )}
      </Menu>
    </div>
  );
};
